import React from 'react';
import { Section } from './Shared';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <Section bg="white" data-id="element-79">
      <div className="max-w-3xl mx-auto bg-slate-900 text-white rounded-3xl p-8 md:p-12 text-center shadow-xl relative overflow-hidden" data-id="element-80">
        {/* Decorative background elements */}
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-white/5 rounded-full blur-3xl" data-id="element-81"></div>
        <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-white/5 rounded-full blur-3xl" data-id="element-82"></div>

        <div className="relative z-10" data-id="element-83">
          <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-84">
            <ShieldCheck className="w-8 h-8 text-white" data-id="element-85" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-86">
            Garantía de Certeza Total.
          </h2>
          <p className="text-lg md:text-xl text-slate-300 mb-6 leading-relaxed" data-id="element-87">
            Si nuestro análisis no te entrega información concreta y accionable
            sobre tu situación pensional real, te devolvemos el 100% de tu
            dinero.
          </p>
          <p className="font-semibold text-white text-lg" data-id="element-88">
            Sin preguntas. Sin procesos complicados. Así de seguros estamos de
            nuestro trabajo.
          </p>
        </div>
      </div>
    </Section>;
}